import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Credits",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10.86 32C4.873 32 0 27.13 0 21.143S4.873 10.286 10.86 10.286s10.858 4.87 10.858 10.857S16.848 32 10.86 32m0-19.429c-4.726 0-8.573 3.846-8.573 8.572s3.847 8.572 8.573 8.572 8.572-3.846 8.572-8.572-3.846-8.572-8.572-8.572"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25.143 20.855c-.435 0-.85-.25-1.04-.672a1.14 1.14 0 0 1 .569-1.511 8.6 8.6 0 0 0 5.043-7.815c0-4.725-3.846-8.571-8.572-8.571a8.6 8.6 0 0 0-7.816 5.042 1.146 1.146 0 0 1-1.511.57 1.14 1.14 0 0 1-.572-1.512A10.89 10.89 0 0 1 21.143 0C27.13 0 32 4.87 32 10.857a10.88 10.88 0 0 1-6.387 9.896c-.151.069-.312.102-.47.102"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.08 13.714a1.14 1.14 0 0 1-1.098-1.458 4.244 4.244 0 0 0-5.24-5.239 1.134 1.134 0 0 1-1.412-.783 1.14 1.14 0 0 1 .783-1.413 6.526 6.526 0 0 1 8.066 8.065c-.143.502-.6.828-1.099.828M10.632 27.429a6.29 6.29 0 0 1-6.282-6.282 6.3 6.3 0 0 1 5.01-6.15c.592-.14 1.223.269 1.348.89a1.14 1.14 0 0 1-.888 1.347 4.01 4.01 0 0 0-3.184 3.913 4 4 0 0 0 3.996 3.996 3.985 3.985 0 0 0 3.971-3.554 1.15 1.15 0 0 1 1.262-1.011c.627.07 1.08.634 1.011 1.261a6.27 6.27 0 0 1-6.244 5.59Z"
    })]
  }));
};
CreditsIcon.displayName = 'CreditsIcon';